<template>
    <div v-if="category">
        <div class="text-center pt-4 pb-4 mx-auto" style="max-width: 900px;">
            <h3 class="category-header">{{ category.category_name }}</h3>
            <p v-if="category.category_desc" v-html="category.category_desc"></p>
            <p v-else>{{ category.product_count_total }} {{ __('redeem.products') }}</p>

<!--            <div v-if="category?.type === 'sfanytime_codes' || category?.type === 'nextory_codes' || category?.type === 'poster'"-->
<!--                 v-html="category?.product?.description"-->
<!--                 class="text-left mx-auto"-->
<!--            ></div>-->
        </div>
        <div v-if="product_list.length" class="product-list mb-5">
            <div v-for="(product, p_index) in product_list" :key="p_index" class="product-list-item">
                <product-box
                    :product="product"
                    :order="order"
                    :points="points"
                    :type="category.type"
                    :testmode="testmode"
                ></product-box>
            </div>
        </div>
        <div class="text-center pb-4">
            <div v-if="showMediaButton" class="pb-4">
                <button v-if="category.type === 'poster'" type="button" class="btn btn btn-light btn-alla btn-lg btn-info btn-lg" style="gap: 10px;" @click.prevent="openModal">
                    {{ __('redeem.info') }}
                </button>
                <a :href="'/'+__('redeem.current_langcode')+'/redeem/media/'+category.prod_id" class="btn btn-primary btn-alla btn-lg">
                    {{ chooseText }}
                </a>
                <form :action="'/'+__('redeem.current_langcode')+'/redeem/media/'+category.prod_id" method="GET" ref="selectform"></form>
            </div>
            <div v-else-if="category.type === 'sfanytime_codes' || category.type === 'nextory_codes'" class="pb-4 d-flex flex-column flex-lg-row justify-content-center align-items-center" style="gap:10px">
                <button type="button" class="btn btn btn-light btn-alla btn-lg btn-info btn-lg" style="gap: 10px;" @click.prevent="openModal">
                    {{ __('redeem.info') }}
                </button>
                <form :action="'/'+__('redeem.current_langcode')+'/redeem/update'" method="POST" ref="selectform">
                    <input type="hidden" name="_token" :value="csrf">
                    <input type="hidden" name="item_id" :value="category.prod_id">
                    <button type="submit" class="btn btn-primary btn-alla btn-lg">
                        {{ chooseText }}
                    </button>
                </form>
            </div>
        </div>

        <product-info-modal
            v-if="category.type === 'sfanytime_codes' || category.type === 'nextory_codes' || category.type === 'poster'"
            ref="modal"
            :product="category.product"
            size="xl"
            type="product"
            @select:gift="() => { if ($refs['selectform']) { $refs['selectform'].submit(); } }"
            :choose-text="chooseText"
        ></product-info-modal>
    </div>
</template>

<script>
import ProductInfoModal from './ProductInfoModal.vue';

export default {
    components: {
        ProductInfoModal,
    },
    props: {
        category: {
            type: Object,
            default() {
                return {};
            },
        },
        points: {
            type: Boolean,
            default: false,
        },
        order: {
            type: Boolean,
            default: false,
        },
        pointsLeft: {
            type: Number,
            default: 0,
        },
        testmode: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        show_all: false,
    }),
    computed: {
        isRedeemed() {
            return !!this.order;
        },
        showMediaButton() {
            return this.category.type === 'pocket_pack'
                || this.category.type === 'magazine_subscription'
                || this.category.type === 'poster';
        },
        product_list() {
            return this.category.products;
        },
        chooseText() {
            if (this.category.btn_text) {
                return this.category.btn_text;
            }
            if (this.category.type === 'sfanytime_codes' || this.category.type === 'nextory_codes') {
                return this.__('redeem.choose') + ' ' + this.category.category_name;
            }
            return this.__('redeem.entire_supply') + ' ' + this.category.category_name;
        },
        maxProducts() {
            if (this.category.type === 'pocket_pack'
            || this.category.type === 'magazine_subscription'
            || this.category.type === 'poster'
            || this.category.type === 'nextory_codes'
            || this.category.type === 'sfanytime_codes') {
                return 8;
            }
            return 12;
        },
    },
    methods: {
        openModal() {
            this.$refs.modal.open();
        },
    },
};
</script>
